import React from 'react';
import { Wrapper, ProfileSlider } from '../components';
import { Accordion } from '../components/Bootstrap';

class CardsView extends React.Component{
    
    render(){
        return (
            <Wrapper>
                <div className="row pb-4">
                    <div className="col-md-12">
                        <h4 className="font-weight-light" title="Responsive, flexible containers that can be used to display a variety of content and elements.">Cards &amp; Widgets</h4>
                        <div className="row py-3">
                            <div className="col-md-6">
                                <div className="card mb-4 wow fadeInUp shadow-sm">
                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col-lg-12">
                                                <ul id="tabsJustified" className="nav nav-tabs nav-fill">
                                                    <li className="nav-item">
                                                        <a href="#home1" data-target="#home1" data-toggle="tab" className="nav-link small text-uppercase">Home</a>
                                                    </li>
                                                    <li className="nav-item">
                                                        <a href="#profile1" data-target="#profile1" data-toggle="tab" className="nav-link small text-uppercase active">Profile</a>
                                                    </li>
                                                    <li className="nav-item">
                                                        <a href="#messages1" data-target="#messages1" data-toggle="tab" className="nav-link small text-uppercase">Messages</a>
                                                    </li>
                                                </ul>
                                                <div id="tabsJustifiedContent" className="tab-content py-3">
                                                    <div className="tab-pane fade" id="home1">
                                                        <div className="list-group"> 
                                                            <span className="list-group-item d-inline-block"><span className="float-right badge badge-pill badge-dark">51</span> Home Link</span>
                                                            <span className="list-group-item d-inline-block"><span className="float-right badge badge-pill badge-dark">8</span> Link 2</span>
                                                            <span className="list-group-item d-inline-block"><span className="float-right badge badge-pill badge-dark">23</span> Link 3</span>
                                                            <span className="list-group-item d-inline-block text-muted">Link n..</span>
                                                        </div>
                                                    </div>
                                                    <div className="tab-pane fade active show" id="profile1">
                                                        <div className="row pb-2">
                                                            <div className="col-lg-7">
                                                                <p>Cards are responsive, flexible containers that can be used to display a variety of content and elements. 
                                                                This Card contains Tabs. Place additional or optional content in subsequent tabs. 
                                                                Enable the user to flow through more information as needed.  
                                                                </p>
                                                            </div>
                                                            <div className="col-lg-5">
                                                                <div className="card h-100 text-center display-2 d-flex justify-content-center rounded-lg py-5">
                                                                    <i className="icons icon-speech"></i>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="tab-pane fade" id="messages1">
                                                        <div className="list-group"> 
                                                            <span className="list-group-item d-inline-block"><span className="float-right badge badge-pill badge-dark">44</span> Message 1</span>
                                                            <span className="list-group-item d-inline-block"><span className="float-right badge badge-pill badge-dark">8</span> Message 2</span>
                                                            <span className="list-group-item d-inline-block"><span className="float-right badge badge-pill badge-dark">23</span> Message 3</span>
                                                            <span className="list-group-item d-inline-block text-muted">Message n..</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="card wow fadeIn shadow-sm mt-4">
                                    <div className="card-img-top card-img-top-300 card-zoom bg-dark p-5">
                                        <svg width="100%" height="100%" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
                                          <image href="assets/undraw/undraw_team.svg" x="0" y="0" height="100" width="100" />
                                        </svg>
                                    </div>
                                    <div className="card-body pt-4">
                                        <h6 className="text-uppercase small">Call to Action</h6>
                                        <h3 className="card-title">Is Everyone on the Same Page?</h3>
                                    </div>
                                </div>
                                
                                <div className="card wow fadeIn shadow-sm mt-4">
                                    <div className="card-header">
                                        <h4 className="font-weight-light mb-0">Login</h4>
                                    </div>
                                    <div className="card-body">
                                        <form className="form" autoComplete="off" id="formLogin">
                                            <div className="form-group">
                                                <label>Username</label>
                                                <input type="text" className="form-control" required />
                                            </div>
                                            <div className="form-group">
                                                <label>Password</label>
                                                <input type="password" className="form-control" required />
                                            </div>
                                            <div className="form-check small">
                                                <label className="form-check-label">
                                                    <input type="checkbox" className="form-check-input" /> <span>Remember me on this computer</span>
                                                </label>
                                            </div>
                                            <button type="button" className="btn btn-success btn-lg float-right">Login</button>
                                        </form>
                                    </div>
                                </div>
                                
                                <div className="card wow fadeIn shadow-sm mt-4">
                                    <div className="card-header">
                                        <h4 className="font-weight-light mb-0">Change Password</h4>
                                    </div>
                                    <div className="card-body">
                                        <form className="form" autoComplete="off">
                                            <div className="form-group">
                                                <label htmlFor="inputPasswordOld">Current Password</label>
                                                <input type="password" className="form-control" id="inputPasswordOld" required="" />
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="inputPasswordNew">New Password</label>
                                                <input type="password" className="form-control" id="inputPasswordNew" required="" />
                                                <span className="form-text small text-muted">
                                                    The password must be 8-20 characters, and must <em>not</em> contain spaces.
                                                </span>
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="inputPasswordNewVerify">Verify</label>
                                                <input type="password" className="form-control" id="inputPasswordNewVerify" required="" />
                                                <span className="form-text small text-muted">
                                                    To confirm, type the new password again.
                                                </span>
                                            </div>
                                            <div className="form-group">
                                                <button type="submit" className="btn btn-success btn-lg float-right">Save</button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                                
                                <div className="card wow fadeIn shadow-sm mt-4">
                                    <div className="card-header">
                                        <h4 className="font-weight-light mb-0">Friends</h4>
                                    </div>
                                    <div className="card-body">
                                        <div className="row text-center text-lg-left">
                                            <div className="col-lg-2">
                                                <img className="rounded-circle img-fluid" src="assets/m20.jpg" alt="Avatar" />
                                            </div>
                                            <div className="col-lg-10">
                                                <h5>Johnny Hotrocker</h5>
                                                <button className="btn btn-secondary btn-sm">Follow +</button>
                                            </div>
                                            <div className="col-12">
                                                <hr />
                                            </div>
                                            <div className="col-lg-2">
                                                <img className="rounded-circle img-fluid" src="assets/w33.jpg" alt="Avatar" />
                                            </div>
                                            <div className="col-lg-10">
                                                <h5>Alice Inchains</h5>
                                                <button className="btn btn-secondary btn-sm">Follow +</button>
                                            </div>
                                            <div className="col-12">
                                                <hr />
                                            </div>
                                            <div className="col-lg-2">
                                                <img className="rounded-circle img-fluid" src="assets/m83.jpg" alt="Avatar" />
                                            </div>
                                            <div className="col-lg-10">
                                                <h5>Theo Flippintown</h5>
                                                <button className="btn btn-secondary btn-sm">Follow +</button>
                                            </div>
                                            <div className="col-12">
                                                <hr />
                                            </div>
                                            <div className="col-lg-2">
                                                <img className="rounded-circle img-fluid" src="assets/w42.jpg" alt="Avatar" />
                                            </div>
                                            <div className="col-lg-10">
                                                <h5>Cary Hausenpoof</h5>
                                                <button type="button" className="btn btn-secondary btn-sm">Follow +</button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card-footer text-right"> 
                                        <button type="button" className="btn btn-link link">Find more..</button>
                                    </div>
                                </div>
                                
                                <div className="row mt-4">
                                    <div className="col-sm-6">
                                        <div className="card h-100 rounded-lg text-white bg-info pt-2">
                                            <div className="card-body py-2">
                                                <span className="small float-right">Dec 2020</span>
                                                <div className="mb-0 display-3">
                                                    <i className="lnr lnr-chart-bars"></i>
                                                </div>
                                                <h5 className="text-uppercase">19% Up</h5>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-sm-6">
                                        <div className="card h-100 rounded-lg text-white bg-info pt-2">
                                            <div className="card-body py-2">
                                                <span className="small float-right">Jan 2021</span>
                                                <div className="mb-0 display-3">
                                                    <i className="lnr lnr-shirt"></i>
                                                </div>
                                                <h5 className="text-uppercase">23 Sales</h5>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                
                                <div className="card mb-2 border-white shadow-sm wow fadeIn mt-4">
                                    <div className="card-header">
                                        <h4 className="font-weight-light mb-0">Testimonial</h4>
                                    </div>
                                    <div className="col-12">
                                        <div className="row bg-white py-3">
                                            <div className="col-12 pt-3">
                                                <h3 className="text-center text-primary my-2">Wilt Kilarno</h3>
                                            </div>
                                            <div className="col-4 mx-auto pb-5">
                                                <svg height="100px" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" className="d-block mx-auto bg-white rounded-circle">
                                                  <image href="assets/undraw/undraw_profile.svg" x="0" y="0" height="100" width="100" />
                                                </svg>
                                            </div>
                                        </div>
                                        <div className="row my-2">
                                            <div className="col-sm-12 p-3">
                                                <blockquote className="blockquote blockquote-reverse">
                                                    <p>"The results were unsurpassed. This is giving us the competitive edge we need. I will be recommending this to my peers without a doubt."</p>
                                                    <div className="blockquote-footer">Wilt, CTO Outsource, Inc.</div>
                                                </blockquote>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="card wow fadeIn shadow-sm mt-4">
                                    <div className="card-header">
                                        <h4 className="font-weight-light mb-0">Carousel Slider</h4>
                                    </div>
                                    <div className="col-12">
                                        <div className="row">
                                            <div className="col-md-12 p-0">
                                                <div id="myCarousel" className="carousel slide" data-ride="carousel" data-interval="1200">
                                                    <div className="carousel-inner rounded-bottom bg-primary py-3" role="listbox">
                                                        <div className="carousel-item px-3 py-4 active">
                                                            <p className="lead text-center text-white">A Simple Slider</p>
                                                            <svg height="250px" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" className="d-block mx-auto">
                                                              <image href="assets/undraw/undraw_messages.svg" x="0" y="0" height="100" width="100" />
                                                            </svg>
                                                        </div>
                                                        <div className="carousel-item px-3 py-4">
                                                            <p className="lead text-center text-white">Boom!</p>
                                                            <svg height="250px" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" className="d-block mx-auto">
                                                              <image href="assets/undraw/undraw_sync.svg" x="0" y="0" height="100" width="100" />
                                                            </svg>
                                                        </div>
                                                        <div className="carousel-item px-3 py-4">
                                                            <p className="lead text-center text-white">Analytics</p>
                                                            <svg height="250px" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" className="d-block mx-auto">
                                                              <image href="assets/undraw/undraw_analytics.svg" x="0" y="0" height="100" width="100" />
                                                            </svg>
                                                        </div>
                                                    </div>
                                                    <ol className="carousel-indicators mt-3">
                                                        <li data-target="#myCarousel" data-slide-to="0" className="active"></li>
                                                        <li data-target="#myCarousel" data-slide-to="1"></li>
                                                        <li data-target="#myCarousel" data-slide-to="2"></li>
                                                    </ol>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                
                                <div className="row wow fadeIn mt-4">
                                    <div className="col pb-1">
                                        <div className="card text-primary bg-white shadow-sm">
                                          <div className="card-body text-center">
                                            <h1 className="card-title mt-2">1</h1>
                                          </div>
                                        </div>
                                    </div>
                                    <div className="col pb-1">
                                        <div className="card text-primary bg-white shadow-sm">
                                          <div className="card-body text-center">
                                            <h1 className="card-title mt-2">2</h1>
                                          </div>
                                        </div>
                                    </div>
                                    <div className="col pb-1">
                                        <div className="card text-primary bg-white shadow-sm">
                                          <div className="card-body text-center">
                                            <h1 className="card-title mt-2">3</h1>
                                          </div>
                                        </div>
                                    </div>
                                </div>
                                
                                <div className="card text-dark wow fadeIn shadow-sm mt-4">
                                  <img src="assets/mtn_2.png" className="card-img" alt="..overlay card.." />
                                  <div className="card-img-overlay">
                                    <h4 className="card-title">Card overlay</h4>
                                    <p className="card-text">Last updated 3 mins ago</p>
                                  </div>
                                </div>
                                
                                <div className="card wow fadeIn shadow-sm mt-4">
                                    <div className="container-fluid">
                                        <div className="row flex-items-middle">
                                            <div className="col-md-5 bg-primary text-center pa-0 rounded-left">
                                                <div className="py-5 text-center">
                                                    <h1 className="m-0"><i className="lnr lnr-apartment"></i></h1>
                                                </div>
                                            </div>
                                            <div className="col-md-7 p-3 d-flex flex-column">
                                                <h3 className="card-title">Horizontal</h3>
                                                <p className="card-text">With supporting side content here.</p>
                                                <button type="button" className="btn btn-outline-secondary btn-block mt-auto">Call-to-action</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="card text-primary bg-white mb-3 wow fadeIn shadow-sm mt-4">
                                  <div className="card-body">
                                    <div className="row align-items-center">
                                        <div className="col-sm-2 col-10 mx-auto px-1">
                                            <img className="rounded-circle img-fluid mx-auto d-block" src="assets/profile_2.png" alt="Avatar" />
                                        </div>
                                        <div className="col">
                                            <span className="small badge badge-dark float-right">2016</span>
                                            <h4 className="font-weight-light">
                                                Wilt H.
                                            </h4>
                                            <p>213 Followers</p>
                                            <button type="button" className="btn btn-sm btn-outline-primary">Follow +</button>
                                        </div>
                                    </div>
                                  </div>
                                </div>
                                
                                <div className="card text-primary bg-white mb-3 wow fadeIn shadow-sm mt-4">
                                  <div className="card-body">
                                    <div className="row align-items-center">
                                        <div className="col-sm-2 col-10 mx-auto px-1">
                                            <img className="rounded-circle img-fluid mx-auto d-block" src="assets/profile_3.png" alt="Avatar" />
                                        </div>
                                        <div className="col">
                                            <span className="small badge badge-dark float-right">2018</span>
                                            <h4 className="font-weight-light">
                                                Alice I.
                                            </h4>
                                            <p>89 Followers</p>
                                            <button type="button" className="btn btn-sm btn-outline-primary">Follow +</button> 
                                            <button type="button" className="btn btn-sm btn-outline-primary ml-2">Contact</button>
                                        </div>
                                    </div>
                                  </div>
                                </div>
                                
                                <div className="card text-primary bg-white mt-4 wow fadeIn shadow-sm">
                                  <div className="card-body">
                                    <div className="row align-items-center">
                                        <div className="col-sm-2 col-10 mx-auto px-1">
                                            <img className="rounded-circle img-fluid mx-auto d-block" src="assets/profile_1.png" alt="Avatar" />
                                        </div>
                                        <div className="col">
                                            <span className="small badge badge-dark float-right">2019</span>
                                            <span className="small badge badge-success float-right mr-2">NEW</span>
                                            <h4 className="font-weight-light">
                                                Mike A
                                            </h4>
                                            <p>12 Followers</p>
                                            <button type="button" className="btn btn-sm btn-outline-primary">Follow +</button>
                                        </div>
                                    </div>
                                  </div>
                                </div>
                                
                                <div className="mt-4 mb-2">
                                    <ProfileSlider />
                                </div>
                                
                            </div>
                            <div className="col-md-6">
                            
                                <div className="card mb-4 wow fadeIn shadow-sm">
                                    <div className="card-header">
                                        <h4 className="font-weight-light mb-0">Widget</h4>
                                    </div>
                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col-xl-6 col-md-12 col-sm-6 tags pb-3">
                                                <span className="badge badge-dark mr-1">bootstrap-4</span>
                                                <span className="badge badge-dark mr-1">navigation</span>
                                                <span className="badge badge-dark mr-1">icons</span>
                                                <span className="badge badge-dark mr-1">carousel</span>
                                                <span className="badge badge-dark mr-1">layout</span>
                                                <span className="badge badge-dark mr-1">panel</span>
                                                <span className="badge badge-dark mr-1">snippet</span>
                                                <span className="badge badge-dark mr-1">cards</span>
                                                <span className="badge badge-dark mr-1">elements</span>
                                                <span className="badge badge-dark mr-1">responsive</span>
                                                <span className="badge badge-dark mr-1">sidebar</span>
                                                <span className="badge badge-dark mr-1">off-canvas</span>
                                                <span className="badge badge-dark mr-1">grid</span>
                                                <span className="badge badge-dark mr-1">slider</span>
                                                <span className="badge badge-dark mr-1">photography</span>
                                            </div>
                                            <div className="col-xl-6 col-md-12 col-sm-6 text-center">
                                                <div className="row mt-1">
                                                    <div className="col-md-12 col-sm-6 pb-3">
                                                        <div className="card border-primary mx-auto">
                                                            <div className="row mx-0">
                                                                <div className="col-md-6 text-center bg-primary text-white py-2">
                                                                    <h5 className="m-0 text-truncate">Cards</h5>
                                                                </div>
                                                                <div className="col-md-6 text-center py-1">
                                                                    <h3 className="m-0 text-primary">78</h3>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12 col-sm-6 pb-3">
                                                        <div className="card border-primary mx-auto">
                                                            <div className="row mx-0">
                                                                <div className="col-md-6 text-center bg-primary text-white py-2">
                                                                    <h5 className="m-0 text-truncate">Widgets</h5>
                                                                </div>
                                                                <div className="col-md-6 text-center py-1">
                                                                    <h3 className="m-0 text-primary">12</h3>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                
                                <Accordion className="my-4 accordion wow fadeIn shadow-sm"/>

                                <div className="card my-4 wow fadeIn shadow-sm">
                                    <div className="card-header">
                                        <h4 className="font-weight-light mb-0">Stats</h4>
                                    </div>
                                    <div className="card-body">
                                        <div className="row pb-2">
                                            <div className="col-lg-12">
                                                <div className="card p-2 border-0"> <span className="text-danger"><span className="badge badge-danger float-right">- 13%</span> Sign-ups </span>
                                                    <div className="progress">
                                                        <div className="progress-bar bg-danger w-25 wow slideInLeft" aria-valuenow="13" aria-valuemin="0" aria-valuemax="100"></div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-12">
                                                <div className="card p-2 border-0"> <span className="text-primary"><span className="badge badge-primary float-right">80%</span> Usage </span>
                                                    <div className="progress">
                                                        <div className="progress-bar w-75 wow slideInLeft" aria-valuenow="80" aria-valuemin="0" aria-valuemax="100"></div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-12">
                                                <div className="card p-2 border-0"> <span className="text-success"><span className="badge badge-success float-right">+ 29%</span> Returning </span>
                                                    <div className="progress">
                                                        <div className="progress-bar bg-success w-50 wow slideInLeft" aria-valuenow="39" aria-valuemin="0" aria-valuemax="100"></div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-12">
                                                <div className="card p-2 border-0"> <span className="text-primary"><span className="badge badge-primary float-right">201</span> Sales </span>
                                                    <div className="progress">
                                                        <div className="progress-bar bg-primary w-75 wow slideInLeft" aria-valuenow="80" aria-valuemin="0" aria-valuemax="100"></div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-12">
                                                <div className="card p-2 border-0"> <span className="text-success"><span className="badge badge-success float-right">+ 24%</span> Pageviews </span>
                                                    <div className="progress">
                                                        <div className="progress-bar bg-success w-25 wow slideInLeft" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                
                                <div className="card my-4 wow fadeIn shadow-sm">
                                    <div className="card-body">
                                        <div className="row lead px-1">
                                            <div className="col-lg-6 text-center">
                                                <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" className="w-75 h-75">
                                                  <image href="assets/undraw/undraw_map.svg" x="0" y="0" height="100" width="100" />
                                                </svg>
                                                <p>Map</p>
                                            </div>
                                            <div className="col-lg-6 text-center">
                                                <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" className="w-75 h-75">
                                                  <image href="assets/undraw/undraw_coding.svg" x="0" y="0" height="100" width="100" />
                                                </svg>
                                                <p>Coding</p>
                                            </div>
                                            <div className="col-lg-6 text-center">
                                                <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" className="w-75 h-75">
                                                  <image href="assets/undraw/undraw_messages.svg" x="0" y="0" height="100" width="100" />
                                                </svg>
                                                <p>Messages</p>
                                            </div>
                                            <div className="col-lg-6 text-center">
                                                <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" className="w-75 h-75">
                                                  <image href="assets/undraw/undraw_online.svg" x="0" y="0" height="100" width="100" />
                                                </svg>
                                                <p>Online</p>
                                            </div>
                                            <div className="col-lg-6 text-center">
                                                <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" className="w-75 h-75">
                                                  <image href="assets/undraw/undraw_grades.svg" x="0" y="0" height="100" width="100" />
                                                </svg>
                                                <p>Reports</p>
                                            </div>
                                            <div className="col-lg-6 text-center">
                                                <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" className="w-75 h-75">
                                                  <image href="assets/undraw/undraw_tutorial.svg" x="0" y="0" height="100" width="100" />
                                                </svg>
                                                <p>Video</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                
                                <div className="wow fadeIn">
                                    <div className="row">
                                        <div className="col-sm-6 py-2">
                                            <div className="card h-100 rounded-lg text-center py-2 shadow-sm">
                                                <div className="card-body card-title">
                                                    <h1 className="mb-1"><i className="icon-social-facebook display-2"></i></h1>
                                                    <h6 className="text-uppercase">56 Likes</h6>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-sm-6 py-2">
                                            <div className="card h-100 rounded-lg text-white bg-primary text-center py-2 shadow-sm">
                                                <div className="card-body card-title">
                                                    <h1 className="mb-1"><i className="icon-social-twitter display-2"></i></h1>
                                                    <h6 className="text-uppercase">209 Followers</h6>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-sm-6 py-2">
                                            <div className="card h-100 rounded-lg text-white bg-success text-center py-2 shadow-sm">
                                                <div className="card-body card-title">
                                                    <h1 className="mb-1"><i className="icon-social-spotify display-2"></i></h1>
                                                    <h6 className="text-uppercase">20 Tunes</h6>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-sm-6 py-2">
                                            <div className="card h-100 rounded-lg text-white bg-danger text-center py-2 shadow-sm">
                                                <div className="card-body card-title">
                                                    <h1 className="mb-1"><i className="icon-social-youtube display-2"></i></h1>
                                                    <h6 className="text-uppercase">1,110 Views</h6>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-sm-6 py-2">
                                            <div className="card h-100 rounded-lg text-white bg-info text-center py-2 shadow-sm">
                                                <div className="card-body card-title">
                                                    <h1 className="mb-1"><i className="icon-social-reddit display-2"></i></h1>
                                                    <h6 className="text-uppercase">90 Views</h6>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-sm-6 py-2">
                                            <div className="card h-100 rounded-lg text-dark bg-warning text-center py-2 shadow-sm">
                                                <div className="card-body card-title">
                                                    <h1 className="mb-1"><i className="icon-social-instagram display-2"></i></h1>
                                                    <h6 className="text-uppercase">44 Apps</h6>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="card my-4 wow fadeIn shadow-sm">
                                    <div className="card-header">
                                        <h4 className="font-weight-light mb-0">Product</h4>
                                    </div>
                                    <div className="col-12 text-center">
                                        <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" className="w-75 h-75">
                                          <image href="assets/undraw/undraw_laravel.svg" x="0" y="0" height="100" width="100" />
                                        </svg>
                                    </div>
                                    <div className="card-body">
                                        <h4 className="font-weight-light mb-0">i312 Desktop 4P</h4>
                                        <p>You'll love this classic with 24mp. Leather case and dark room guide included.</p>
                                        <p className="lead">$89.00</p>
                                        <hr />
                                        <div className="row">
                                            <div className="col-6">
                                                <p className="small">12 in stock
                    ships: 8/22</p>
                                            </div>
                                            <div className="col-6">
                                                <button className="btn btn-outline-secondary btn-lg btn-block">Order</button>
                                            </div>
                                        </div>
                                        <hr />
                                        <a href="./" className="small">More `retro cameras`</a>
                                    </div>
                                </div>
                                
                                <div className="card my-4 wow fadeIn shadow-sm">
                                    <div className="card-header">
                                        <h4 className="font-weight-light mb-0">Multi Slider</h4>
                                    </div>
                                    <div className="container-fluid">
                                        <div className="row">
                                            <div className="col-md-12 py-5 bg-info">
                                                <h5 className="text-center mb-0">12-Day Forecast</h5>
                                            </div>
                                            <div className="col-md-12">
                                                <div id="myCarousel2" className="carousel pt-1" data-ride="carousel" data-interval="2500">
                                                    <div className="carousel-inner" role="listbox">
                                                        <div className="carousel-item active">
                                                            <div className="row py-5 text-center text-info">
                                                                <div className="col-md-3">
                                                                    <h1><i className="lnr lnr-sun display-4"></i></h1>
                                                                    <label>Today</label>
                                                                </div>
                                                                <div className="col-md-3">
                                                                    <h1><i className="lnr lnr-cloud display-4"></i></h1>
                                                                    <label>Tomorrow</label>
                                                                </div>
                                                                <div className="col-md-3">
                                                                    <h1><i className="lnr lnr-moon display-4"></i></h1>
                                                                    <label>Day 3</label>
                                                                </div>
                                                                <div className="col-md-3">
                                                                    <h1><i className="lnr lnr-cloud display-4"></i></h1>
                                                                    <label>Day 4</label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="carousel-item">
                                                            <div className="row py-5 text-center text-info">
                                                                <div className="col-md-3">
                                                                    <h1><i className="lnr lnr-cloud display-4"></i></h1>
                                                                    <label>Day 5</label>
                                                                </div>
                                                                <div className="col-md-3">
                                                                    <h1><i className="lnr lnr-sun display-4"></i></h1>
                                                                    <label>Day 6</label>
                                                                </div>
                                                                <div className="col-md-3">
                                                                    <h1><i className="lnr lnr-moon display-4"></i></h1>
                                                                    <label>Day 7</label>
                                                                </div>
                                                                <div className="col-md-3">
                                                                    <h1><i className="lnr lnr-sun display-4"></i></h1>
                                                                    <label>Day 8</label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="carousel-item">
                                                             <div className="row py-5 text-center text-info">
                                                                <div className="col-md-3">
                                                                    <h1><i className="lnr lnr-sun display-4"></i></h1>
                                                                    <label>Day 9</label>
                                                                </div>
                                                                <div className="col-md-3">
                                                                    <h1><i className="lnr lnr-moon display-4"></i></h1>
                                                                    <label>Day 10</label>
                                                                </div>
                                                                <div className="col-md-3">
                                                                    <h1><i className="lnr lnr-cloud display-4"></i></h1>
                                                                    <label>Day 11</label>
                                                                </div>
                                                                <div className="col-md-3">
                                                                    <h1><i className="lnr lnr-sun display-4"></i></h1>
                                                                    <label>Day 12</label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <ol className="carousel-indicators relative carousel-indicators-highlight">
                                                        <li data-target="#myCarousel2" data-slide-to="0" className="active bg-info"></li>
                                                        <li data-target="#myCarousel2" data-slide-to="1" className="bg-info"></li>
                                                        <li data-target="#myCarousel2" data-slide-to="2" className="bg-info"></li>
                                                    </ol>
                                                 </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="card my-4 wow fadeIn shadow-sm">
                                    <div className="card-header">
                                        <h4 className="font-weight-light mb-0">Profile</h4>
                                    </div>
                                    <div className="px-3">
                                        <div className="row bg-light py-4">
                                            <div className="col-4 mx-auto py-4">
                                                <img className="rounded-circle img-fluid mx-auto d-block" src="assets/profile_1.png" alt="Avatar" />
                                            </div>
                                        </div>
                                        <div className="row my-2">
                                            <div className="col-sm-12 pt-2">
                                                <div className="card-body text-center">
                                                    <h3 className="mb-0">Lydia</h3>
                                                    <span className="text-muted font-weight-normal">@ohLydia</span>
                                                    <p className="mt-1">"I wish I didn't get rid of ya!"</p>
                                                    <hr />
                                                    <div className="row">
                                                        <div className="col-md-12 col-lg-10 col-xl-8 mx-md-auto">
                                                            <div className="row">
                                                                <div className="col-4 text-center border-right">
                                                                    <h4 className="mb-0">9</h4>
                                                                    <a href="./" className="small text-wide text-uppercase font-weight-normal">likes</a>
                                                                </div>
                                                                <div className="col-4 text-center border-right">
                                                                    <h4 className="mb-0">22</h4>
                                                                    <a href="./" className="small text-wide text-uppercase font-weight-normal">posts</a>
                                                                </div>
                                                                <div className="col-4 text-center">
                                                                    <h4 className="mb-0">15</h4>
                                                                    <a href="./" className="small text-wide text-uppercase font-weight-normal">friends</a>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                
                                <div className="row my-4">
                                    <div className="col-lg-6 pb-2">
                                        <div className="card text-white bg-primary mb-3 wow fadeIn shadow-sm">
                                          <div className="card-header">Header</div>
                                          <div className="card-body">
                                            <h5 className="card-title">Primary card title</h5>
                                            <p className="card-text">Some quick example text to build on the card title.</p>
                                          </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-6 pb-2">
                                        <div className="card text-white bg-secondary mb-3 wow fadeIn shadow-sm">
                                          <div className="card-header">Header</div>
                                          <div className="card-body">
                                            <h5 className="card-title">Secondary card title</h5>
                                            <p className="card-text">Some quick example text to build on the card title.</p>
                                          </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-6 pb-2">
                                        <div className="card text-white bg-success mb-3 wow fadeIn shadow-sm">
                                          <div className="card-header">Header</div>
                                          <div className="card-body">
                                            <h5 className="card-title">Success card title</h5>
                                            <p className="card-text">Some quick example text to build on the card title.</p>
                                          </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-6 pb-2">
                                        <div className="card text-white bg-danger mb-3 wow fadeIn shadow-sm">
                                          <div className="card-header">Header</div>
                                          <div className="card-body">
                                            <h5 className="card-title">Danger card title</h5>
                                            <p className="card-text">Some quick example text to build on the card title.</p>
                                          </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-6 pb-2">
                                        <div className="card text-dark bg-warning mb-3 wow fadeIn shadow-sm">
                                          <div className="card-header">Header</div>
                                          <div className="card-body">
                                            <h5 className="card-title">Warning card title</h5>
                                            <p className="card-text">Some quick example text to build on the card title.</p>
                                          </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-6 pb-2">
                                        <div className="card text-white bg-dark mb-3 wow fadeIn shadow-sm">
                                          <div className="card-header">Header</div>
                                          <div className="card-body">
                                            <h5 className="card-title">Dark card title</h5>
                                            <p className="card-text">Some quick example text to build on the card title.</p>
                                          </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-6 pb-2">
                                        <div className="card text-white bg-info mb-3 wow fadeIn shadow-sm">
                                          <div className="card-header">Header</div>
                                          <div className="card-body">
                                            <h5 className="card-title">Info card title</h5>
                                            <p className="card-text">Some quick example text to build on the card title.</p>
                                          </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-6 pb-2">
                                        <div className="card bg-light mb-3 wow fadeIn shadow-sm">
                                          <div className="card-header">Header</div>
                                          <div className="card-body">
                                            <h5 className="card-title">Light card title</h5>
                                            <p className="card-text">Some quick example text to build on the card title.</p>
                                          </div>
                                        </div>
                                    </div>
                                </div>
                                
                            </div>
                        </div>
                    </div>
                </div>
            </Wrapper>
        );
    }
}

export default CardsView;
